import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss']
})
export class SingleSelectComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:'',
  }
  public componentType:string = "";
  constructor(public qService:QuestionService, public aService:AnswerService,public notifier: NotifierService) { 
    this.componentType = this.qService.questionType.SINGLE_SELECT
    this.qService.refreshAnsBody
    .subscribe((question_type:string) =>{
      if (question_type == this.componentType) {
        this.resetAnsBody();
      }
    })
  }

  ngOnInit(): void {
  }

  selectOption(value:any){
    // console.log(value)
    this.ansBody.question_label = this.qService.currentQuestion.question_label;
    this.ansBody.question_name = this.qService.currentQuestion.question_name;
    this.ansBody.answer_text = value.label;
  }

  next(){
    // console.log(this.ansBody)
    if (!this.ansBody.answer_text || this.ansBody.answer_text == '') {
      this.notifier.notify('error',"Please select a value");
      return;
    }
    this.aService.submitAnswer(this.ansBody);
    // this.resetAnsBody();
    // setTimeout(() => {
    //   this.resetAnsBody();
    // }, 100);
  }

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:'',
    }
  }
}
